import { Link, useParams } from "react-router-dom";
import { findProject, projects } from "../../constants/projects";
import { ArrowIcon, MediaReveal, Reveal, SplitReveal } from "../../components/motion";
import { CONTACT_MAILTO } from "../../components/Header";
import WorkItem from "../../components/WorkItem";

const ExternalLink = ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" className="link-arrow">
        <span className="label">{children}</span>
        <ArrowIcon className="arrow" />
    </a>
);

const Fact = ({ label, children }) => (
    <div className="border-t border-ink-100 py-5">
        <p className="t-small text-ink-500">{label}</p>
        <p className="t-body mt-1">{children}</p>
    </div>
);

const WorkDetail = () => {
    const { name } = useParams();
    const work = findProject(name);

    if (!work) {
        return (
            <div className="container-site flex min-h-[50vh] flex-col items-start justify-center">
                <p className="t-intro">Proje bulunamadı.</p>
                <Link to="/projeler" className="link-arrow mt-6"><span className="label">Tüm projeler</span><ArrowIcon className="arrow" /></Link>
            </div>
        );
    }

    const index = projects.findIndex((p) => p.slug === work.slug);
    const next = projects[(index + 1) % projects.length];

    return (
        <div className="bg-white">
            <section className="container-site pt-[48px] md:pt-[96px]">
                <Reveal>
                    <p className="t-eyebrow">{work.kind} · {work.sector}</p>
                </Reveal>
                <h1 className="t-display mt-4 max-w-[900px]">
                    <SplitReveal text={work.title} />
                </h1>
                <div className="mt-10 grid grid-cols-1 gap-12 lg:grid-cols-12">
                    <Reveal delay={0.1} className="lg:col-span-7">
                        <p className="t-intro font-normal">{work.blurb}.</p>
                        <p className="t-body mt-6 max-w-[640px] text-ink-600">{work.description}</p>
                        {(work.links.length > 0 || work.landing) && (
                            <div className="mt-8 flex flex-wrap gap-x-10 gap-y-4">
                                {work.landing && (
                                    <Link to={work.landing} className="link-arrow"><span className="label">Tanıtım sayfası</span><ArrowIcon className="arrow" /></Link>
                                )}
                                {work.links.map((link) => (
                                    <ExternalLink key={link.href} href={link.href}>{link.label}</ExternalLink>
                                ))}
                            </div>
                        )}
                    </Reveal>
                    <Reveal delay={0.2} className="lg:col-span-4 lg:col-start-9">
                        <Fact label="Müşteri">{work.client}</Fact>
                        <Fact label="Yıl">{work.year}</Fact>
                        <Fact label="Hizmetler">{work.services.join(", ")}</Fact>
                        <Fact label="Teknolojiler">{work.stack.join(", ")}</Fact>
                        <div className="border-t border-ink-100" />
                    </Reveal>
                </div>
            </section>

            <section className="container-site pt-[64px] md:pt-[96px]">
                <MediaReveal>
                    <div className="pointer-events-none">
                        <WorkItem item={{ ...work, blurb: "", client: "", sector: "" }} index={0} />
                    </div>
                </MediaReveal>

                {work.gallery.length > 0 && (
                    <div className="mt-12 grid grid-cols-1 gap-12 md:mt-24 md:grid-cols-2 md:gap-x-12 xl:gap-x-[114px] md:[&>*:nth-child(even)]:mt-[120px]">
                        {work.gallery.map((photo, idx) => (
                            <MediaReveal key={idx} delay={idx * 0.1}>
                                <div className="flex aspect-[4/5] items-center justify-center bg-ink-50 p-8">
                                    <img src={photo} alt={`${work.title} görseli ${idx + 1}`} className="max-h-full w-auto max-w-full object-contain" loading="lazy" />
                                </div>
                            </MediaReveal>
                        ))}
                    </div>
                )}
            </section>

            <section className="container-site flex flex-col items-start gap-8 pb-[120px] pt-[96px] md:flex-row md:items-center md:justify-between md:pt-[140px]">
                <Reveal>
                    <h2 className="t-h2 max-w-[640px]">Benzer bir ürün mü istiyorsunuz?</h2>
                </Reveal>
                <Reveal delay={0.1} className="flex flex-wrap items-center gap-x-10 gap-y-4">
                    <a href={CONTACT_MAILTO} className="btn-pill">İletişime geçin</a>
                    <Link to={`/projeler/${next.slug}`} className="link-arrow"><span className="label">Sonraki: {next.title}</span><ArrowIcon className="arrow" /></Link>
                </Reveal>
            </section>
        </div>
    );
};

export default WorkDetail;
